module.exports = __webpack_public_path__ + "img/dr_15.c1d2cdb8.png";